"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThumbnailList = void 0;
var _react = _interopRequireDefault(require("react"));
var _Gallery = require("b2b-components/theme/components/Gallery");
var _image = require("b2b-components/theme/components/Gallery/utils/image");
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
var _Thumbnail = require("./Thumbnail");
var _ThumbnailIcon = require("./ThumbnailIcon");
var _ThumbnailImage = require("./ThumbnailImage");
var ThumbnailList = function ThumbnailList(_ref) {
  var currentItemIndex = _ref.currentItemIndex,
    images = _ref.images,
    image360 = _ref.image360,
    imageUrl = _ref.imageUrl,
    isMobile = _ref.isMobile,
    isPreview = _ref.isPreview,
    itemIndexArray = _ref.itemIndexArray,
    moreItemCount = _ref.moreItemCount,
    onMoreThumbnailClick = _ref.onMoreThumbnailClick,
    onThumbnailClick = _ref.onThumbnailClick,
    title = _ref.title,
    totalItemCount = _ref.totalItemCount,
    videos = _ref.videos;
  var rootClassName = (0, _classnames["default"])('cds-Gallery-ThumbnailList', {
    'cds-Gallery-ThumbnailList--Preview': isPreview
  });
  var itemIndex = 0;
  if (!images && !image360 && !videos) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, images && !isMobile && images.map(function (image) {
    return /*#__PURE__*/_react["default"].createElement(_Thumbnail.Thumbnail, {
      isCurrent: currentItemIndex === itemIndexArray[itemIndex],
      isPreview: isPreview,
      onClick: onThumbnailClick(itemIndexArray[itemIndex]),
      totalItemCount: totalItemCount,
      type: _Gallery.GALLERY_ITEM_TYPE.image,
      key: itemIndex++
    }, /*#__PURE__*/_react["default"].createElement(_ThumbnailImage.ThumbnailImage, {
      src: (0, _image.getImageSrc)(image, imageUrl, _image.IMAGE_SIZE.thumbnail),
      title: title
    }));
  }), image360 && !isMobile && /*#__PURE__*/_react["default"].createElement(_Thumbnail.Thumbnail, {
    isCurrent: currentItemIndex === itemIndexArray[itemIndex],
    isPreview: isPreview,
    onClick: onThumbnailClick(itemIndexArray[itemIndex]),
    totalItemCount: totalItemCount,
    type: _Gallery.GALLERY_ITEM_TYPE.image360,
    key: itemIndex++
  }, /*#__PURE__*/_react["default"].createElement(_ThumbnailImage.ThumbnailImage, {
    src: (0, _image.getImage360Src)(image360, imageUrl, images),
    title: title
  }), /*#__PURE__*/_react["default"].createElement(_ThumbnailIcon.ThumbnailIcon, null, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    name: _Icon.ICON_NAME.rotate360
  }))), videos && videos.map(function (video) {
    return /*#__PURE__*/_react["default"].createElement(_Thumbnail.Thumbnail, {
      href: video.link,
      isCurrent: currentItemIndex === itemIndexArray[itemIndex],
      isPreview: isPreview,
      onClick: onThumbnailClick(itemIndexArray[itemIndex]),
      totalItemCount: totalItemCount,
      type: _Gallery.GALLERY_ITEM_TYPE.video,
      key: itemIndex++
    }, /*#__PURE__*/_react["default"].createElement(_ThumbnailImage.ThumbnailImage, {
      src: video.thumbnailUrl,
      title: title
    }), /*#__PURE__*/_react["default"].createElement(_ThumbnailIcon.ThumbnailIcon, null, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      name: _Icon.ICON_NAME.video
    })));
  }), moreItemCount > 0 && /*#__PURE__*/_react["default"].createElement(_Thumbnail.Thumbnail, {
    isPreview: isPreview,
    onClick: onMoreThumbnailClick,
    totalItemCount: totalItemCount,
    type: _Gallery.GALLERY_ITEM_TYPE.more
  }, "+", moreItemCount));
};
exports.ThumbnailList = ThumbnailList;